export default "__VITE_ASSET__Bm7wrlB0__"